import React, {Component} from "react";
import { inject, observer } from 'mobx-react'
import FontAwesome from 'react-fontawesome';
import {Holdable, defineHold} from 'react-touch';
import {Button, ButtonGroup, Label, Container} from "reactstrap";
import {Link} from "react-router-dom";
import {extendObservable} from "mobx";
import TituloPaginaStore from "../stores/TituloPaginaStore";

@inject("store")
@observer
export default class TituloPagina extends Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.controller = this.props.store.tituloPaginaStore;
    }

    gerarBotoes() {
        const botoesMobile = [];

        this.controller.botoesMobile.map((botao, i) => {
            botoesMobile.push(
                <li className={"page-title-button"} key={i}>
                    <a key={i} title={botao.label} onClick={() => botao.acao()}>{botao.icone ? <FontAwesomeIcon name={botao.icone} /> : botao.label }</a>
                </li>
            )
        });

        return botoesMobile
    }

    render() {
        return (
            <Container fluid>
                {this.controller.titulo ? (
                <div>
                    <ul className="page-title-with-button">
                        <li>
                            {this.controller.titulo &&
                                (
                                    <React.Fragment>
                                        <h1>{this.controller.titulo}
                                            { this.controller.status
                                                ? this.controller.status
                                                : ""
                                            }
                                        </h1>
                                    </React.Fragment>
                                )
                            }
                            {this.controller.subtitulo &&
                                (<h2>{this.controller.subtitulo}</h2>)
                            }
                            
                        </li>
                        {this.appStore.width <= 768 && this.controller.botoesMobile && this.controller.botoesMobile.length > 0 &&
                            this.gerarBotoes()
                        }
                    </ul>
                </div>
                ) : (
                    <br />
                )}
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/TituloPagina.js